import { render, staticRenderFns } from "./LessonParagraph.vue?vue&type=template&id=6fe58fee&"
import script from "./LessonParagraph.vue?vue&type=script&lang=js&"
export * from "./LessonParagraph.vue?vue&type=script&lang=js&"
import style0 from "./LessonParagraph.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LessonParagraph.vue"
export default component.exports